import React from "react";

import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import HistoricalMetricPage from "./HistoricalMetricPage";

/**
 * INSIGHT-HIST-12 — Historical Preparation performance.
 */
const HistoricalPreparationPage: React.FunctionComponent<{}> = () => (
  <HistoricalMetricPage metricType="PREPARATION" title="Preparation Time Report" />
);

export default withAuthority(
  HistoricalPreparationPage,
  Authorities.CUSTOMER_LIST_READ
);
